import React from "react";

const SearchLoadingSkeleton: React.FC<{ title: string }> = ({
  title: _title,
}) => {
  const SkeletonItem = ({ delay = 0 }: { delay?: number }) => (
    <div className="flex items-start gap-3 p-3 rounded-lg">
      {/* Icon skeleton */}
      <div
        className="w-5 h-5 rounded animate-pulse bg-gray-200 dark:bg-neutral-700"
        style={{ animationDelay: `${delay}ms` }}
      />

      <div className="flex-1 space-y-2">
        {/* Title skeleton */}
        <div
          className="h-4 rounded animate-pulse bg-gray-200 dark:bg-neutral-700"
          style={{
            width: `${60 + Math.random() * 30}%`,
            animationDelay: `${delay + 100}ms`,
          }}
        />

        {/* Date skeleton */}
        <div
          className="h-3 w-16 rounded animate-pulse bg-gray-200 dark:bg-neutral-700"
          style={{ animationDelay: `${delay + 200}ms` }}
        />
      </div>
    </div>
  );

  const SkeletonSection = ({
    title: _title,
    itemCount,
    baseDelay = 0,
  }: {
    title: string;
    itemCount: number;
    baseDelay?: number;
  }) => (
    <div className="space-y-2">
      {/* Section title skeleton */}
      <div
        className="h-4 w-20 rounded animate-pulse mb-3 bg-gray-300 dark:bg-neutral-600"
        style={{ animationDelay: `${baseDelay}ms` }}
      />

      {/* Items skeleton */}
      {Array.from({ length: itemCount }).map((_, index) => (
        <SkeletonItem key={index} delay={baseDelay + (index + 1) * 150} />
      ))}
    </div>
  );

  return (
    <div className="space-y-6">
      <SkeletonSection title="Today" itemCount={2} baseDelay={0} />
      <SkeletonSection title="Last 7 Days" itemCount={3} baseDelay={300} />
      <SkeletonSection title="Last 30 Days" itemCount={2} baseDelay={900} />
    </div>
  );
};

export default SearchLoadingSkeleton;
